import Vue from 'vue';
import Router from 'vue-router';
import LastArticles from '@/components/LastArticles';
import ArticlePage from '@/components/ArticlePage';
import PressReleasePage from '@/components/PressReleasePage';
import ArticlesForCategory from '@/components/ArticlesForCategory';
import ArticlesSearch from '@/components/ArticlesSearch';
import RGPD from '@/components/RGPD';
import NotFound from '@/components/NotFound';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'LastArticles',
      component: LastArticles,
    },
    {
      path: '/articles/:id/:slug',
      name: 'ArticlePage',
      component: ArticlePage,
    },
    {
      path: '/communiques-de-press/:id/:slug',
      name: 'PressReleasePage',
      component: PressReleasePage,
    },
    {
      path: '/articles/:categoryValue',
      name: 'ArticlesForCategory',
      component: ArticlesForCategory,
    },
    {
      path: '/lvn/:categoryValue',
      name: 'ArticlesForLVNCategory',
      component: ArticlesForCategory,
    },
    {
      path: '/articles/:query?',
      name: 'ArticlesSearch',
      component: ArticlesSearch,
    },
    {
      path: '/rgpd',
      name: 'RGPD',
      component: RGPD,
    },
    { path: '/erreur/404', component: NotFound },
    { path: '*', redirect: '/erreur/404' },
  ],
});

router.afterEach(() => {
  $('.backdrop').click();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js